export  function featuredCarousel() {
    $(".featured-carousel").each(function () {
        let curSliderWrap = $(this);
        let curSlider = curSliderWrap.find(".swiper-container");
		
        let  swiperOptions = {
            watchOverflow: true,
            // effect: 'fade',
            // fadeEffect: {
            //     crossFade: true
            // },
            spaceBetween: 10,
            slidesPerView: 1,
            // centeredSlides: true,
            // freeMode: true,
            navigation: {
                nextEl: `.${curSliderWrap.find(".swiper-button-next").attr("class")}`,
                prevEl: `.${curSliderWrap.find(".swiper-button-prev").attr("class")}`,
            },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                    spaceBetween: 22,
                },
            }
        };

        let swiper = new Swiper(`.${curSlider.attr("class")}`, swiperOptions);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/featuredCarousel.js